module.exports = __webpack_public_path__ + "static/media/trophy.1bc0b434.svg";